import { Box, Button, Divider, Grid, Switch, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ReviewYourShipment({ selectCardData }) {
  const navigation = useNavigate();

  return (
    <>
      {selectCardData === null ? (
        <Box
          sx={{
            backgroundColor: "#F5F5F5",
            borderRadius: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: 14,
            color: "#999",
            height: "100%",
            minHeight: 200,
            textAlign: "center",
          }}
        >
          Select available shipment
        </Box>
      ) : (
        <Box>
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "20px",
                color: "#000000",
              }}
            >
              Review Your Shipment
            </Typography>
          </Box>

          <Box
            sx={{
              border: "1px solid #E5E5E8",
              borderRadius: "12px",
              mt: 3,
              p: 2,
            }}
          >
            {/* Header Section */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                borderBottom: "1px solid #E5E5E8",
                pb: 2,
              }}
            >
              <img src={selectCardData.logo} alt="UPS" width={48} />
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1C2630",
                  }}
                >
                  {selectCardData.title}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "12px",
                    color: "#1C2630",
                  }}
                >
                  {selectCardData.days}
                </Typography>
              </Box>
            </Box>

            {/* Package Details and Delivery Address */}
            <Grid
              container
              spacing={2}
              sx={{ mt: 2, borderBottom: "1px solid #E5E5E8", pb: 2 }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                sx={{ borderRight: "1px solid #E5E5E8", pb: 2 }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "14px",
                    color: "#959BA1",
                    mb: 1,
                  }}
                >
                  PACKAGE DETAILS
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#1C2630",
                    mb: 1,
                  }}
                >
                  Weight: 5.5 lbs
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    mb: 1,
                    color: "#1C2630",
                  }}
                  variant="body2"
                >
                  Dimensions : 12”x 8”x 6”
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "14px",
                    color: "#959BA1",
                    mb: 1,
                  }}
                >
                  DELIVERY ADDRESS
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#1C2630",
                    mb: 1,
                  }}
                >
                  Weight: 5.5 lbs
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#1C2630",
                    mb: 1,
                  }}
                >
                  Dimensions : 12”x 8”x 6”
                </Typography>
              </Grid>
            </Grid>

            {/* Toggle Options */}
            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  backgroundColor: "#F8F8F8",
                  border: "1px solid #E5E5E8",
                  borderRadius: 2,
                  p: 2,
                  mb: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography fontSize={14}>Import Duties & Taxes</Typography>
                <Switch defaultChecked />
              </Box>

              <Box
                sx={{
                  backgroundColor: "#F8F8F8",
                  border: "1px solid #E5E5E8",
                  borderRadius: 2,
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography fontSize={14}>Shipping Insurance</Typography>
                <Switch defaultChecked />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              border: "1px solid #E5E5E8",
              borderRadius: "12px",
              backgroundColor: "#FAFAFA",
              p: 2,
              mt: 2,
            }}
          >
            {/* Title */}
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 14,
                color: "#959BA1",
                mb: 2,
              }}
            >
              COST BREAKDOWN
            </Typography>

            {/* Item Rows */}
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography>Shipping Cost</Typography>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "right" }}>
                <Typography> {selectCardData.price}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography>Duties & Taxes</Typography>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "right" }}>
                <Typography>$12.50</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography>Insurance</Typography>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "right" }}>
                <Typography>$8.00</Typography>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* Total */}
            <Grid container>
              <Grid item xs={6}>
                <Typography fontWeight={700}>Total Amount</Typography>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "right" }}>
                <Typography fontWeight={700}>$65.50</Typography>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              borderTop: "1px solid #E5E5E8",
              backgroundColor: "#FAFAFA",
              mt: 2,
              textAlign: "right",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                mt: 1,
                "&:hover": {
                  outline: "none",
                  color: "white",
                  backgroundColor: "#5E17EB",
                },
              }}
              onClick={() => {
                navigation(
                  "/shipping/get-shipping-quote/result/completeYourPayment"
                );
              }}
            >
              Proceed to Payment
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
}

export default ReviewYourShipment;
